
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goi-kham-suc-khoe-tam-soat-ung-thu-som",
      function () {
        return require("private-next-pages/goi-kham-suc-khoe-tam-soat-ung-thu-som/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goi-kham-suc-khoe-tam-soat-ung-thu-som"])
      });
    }
  